import {
  Box,
  Grid,
  MenuItem,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";

import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import C1DateField from "app/c1component/C1DateField";
import C1HeaderTitle from "app/c1component/C1HeaderTitle";
import C1InputField from "app/c1component/C1InputField";
import C1SelectField from "app/c1component/C1SelectField";
import useHttp from "app/c1hooks/http";
import useAuth from "app/hooks/useAuth";
import cacheDataService from "app/services/cacheDataService";
import { MatxLoading } from "matx";
import RaeoHistory from "./RaeoHistory";
import RaeoAppAssessmentItem from "./RaeoAppAssessmentItem";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    backgroundColor: "#3c77d0",
  },
}));

const RaeoAppDetails = ({
    inputData,
    handleDateChange,
    handleInputChangeDeep,
    onAssessmentValidation,
    auditList,
    setInputData,
    errors,
    isDisabled,}) => {

  const { user } = useAuth();

  const [refreshPage, setRefreshPage] = useState(0);

  useEffect(() => {
    //validateForm();
  }, [inputData]);

  const classes = useStyles();

  let sctRaeoAppDtl = inputData.TSctRaeoAppDtl || {};
  const isOperatorAdmin = user.authorities.some(
    (authority) => authority.authority === "RAEO_OPERATOR_ADMIN"
  );

  sctRaeoAppDtl.appdApplicantName = isOperatorAdmin
    ? user.name
    : sctRaeoAppDtl.appdApplicantName;
  sctRaeoAppDtl.appdTel = isOperatorAdmin
    ? user.coreAccn?.accnContact?.contactTel
    : sctRaeoAppDtl.appdTel;
  sctRaeoAppDtl.appdEmail = isOperatorAdmin
    ? user.coreAccn?.accnContact?.contactEmail
    : sctRaeoAppDtl.appdEmail;
  sctRaeoAppDtl.appdAddr1 = isOperatorAdmin
    ? user.coreAccn?.accnAddr?.addrLn1
    : sctRaeoAppDtl.appdAddr1;
  sctRaeoAppDtl.appdAddr2 = isOperatorAdmin
    ? user.coreAccn?.accnAddr?.addrLn2
    : sctRaeoAppDtl.appdAddr2;
  sctRaeoAppDtl.appdAddr3 = isOperatorAdmin
    ? user.coreAccn?.accnAddr?.addrLn3
    : sctRaeoAppDtl.appdAddr3;

  let businessNatureList = cacheDataService.getItemData("sctRaeoMstBzNature");
  let rangeList = cacheDataService.getItemData("sctRaeoMstRange");
  let countryList = cacheDataService.getItemData("country");
  //console.log("countryList", countryList);

  const [expandedList, setExpandedList] = useState([]);
  const [groupAssessArray, setGroupAssessArray] = useState([]);

  //console.log("assessArray", assessArray);
  const groupByAssess = () => {
    let assessArray = inputData.TSctRaeoAppAssessments || [];

    assessArray.sort(
      (a1, a2) =>
        a1?.TSctRaeoMstAssessment?.asmSeq - a2?.TSctRaeoMstAssessment?.asmSeq
    );

    let groupAssessArray = assessArray.reduce((accumulator, item) => {
      //accumulator + currentValue.jtJobDn
      let asmSeq = item.TSctRaeoMstAssessment?.asmSeq;
      let groupId = Math.floor(asmSeq);
      let idx = accumulator.findIndex(
        (assess) => groupId === assess?.header?.TSctRaeoMstAssessment?.asmSeq
      );
      //console.log("---", asmSeq, groupId, idx, accumulator);

      if (asmSeq === groupId) {
        // header
        if (idx < 0) {
          accumulator.push({ header: item, body: [] });
          expandedList.push(true);
        }
      } else {
        // body
        if (idx >= 0) {
          accumulator[idx].body.push(item);
        }
      }
      return accumulator;
    }, []);
    /*
    groupAssessArray.map( (item, idx) => {
        item.body.sort( (a1, a2) => {
            console.log("--", a1?.TSctRaeoMstAssessment?.asmSeq, a2?.TSctRaeoMstAssessment?.asmSeq
                , a1?.TSctRaeoMstAssessment?.asmSeq - a2?.TSctRaeoMstAssessment?.asmSeq);
            return a1?.TSctRaeoMstAssessment?.asmSeq - a2?.TSctRaeoMstAssessment?.asmSeq });
    });*/
    console.log("groupAssessArray", groupAssessArray);

    return groupAssessArray;
    // accumulator = [{header:{}, body:[{},{}]},{header:{}, body:[{},{}]}]
  };

  useEffect(() => {
    setGroupAssessArray(groupByAssess());
  }, [inputData]);

  useEffect(() => {
    //validateForm();
  }, [groupAssessArray]);

  const handleChange = (idx) => {
    expandedList[idx] = !expandedList[idx];
    setExpandedList(...[expandedList]);
    setRefreshPage(refreshPage + 1);
  };

  const handleInputChangeCommon = (e, apasId) => {
    const { name, value } = e.target;
    const updatedAssessments = inputData.TSctRaeoAppAssessments.map(
      (assess) => {
        if (assess.apasId === apasId) {
          if (name === "apasResponseReason") {
            const selectedValue = assess.apasResponse?.split(":")[0] || "";
            return {
              ...assess,
              apasResponseReason: value,
              apasResponse: `${selectedValue}:${value}`,
            };
          } else if (name === "apasResponse") {
            const reason = assess.apasResponseReason ;
            if(reason) {
                return { ...assess, apasResponse: `${value}:${reason}` };
            } else {
                return { ...assess, apasResponse: `${value}` };
            }
          } else {
            return { ...assess, [name]: value };
          }
        }
        return assess;
      }
    );

    setInputData({ ...inputData, TSctRaeoAppAssessments: updatedAssessments });

    // setRefreshPage(refreshPage + 1);
    //validateForm();
  };

  const handleCheckboxChange = (e, apasId) => {
    const { value } = e.target;
    const updatedAssessments = inputData.TSctRaeoAppAssessments.map(
      (assess) => {
        if (assess.apasId === apasId) {
          const reason = assess.apasResponseReason || "";
          //return { ...assess, apasResponse: `${value}:${reason}` };
          return { ...assess, apasResponse: `${value}` };
        }
        return assess;
      }
    );

    setInputData({ ...inputData, TSctRaeoAppAssessments: updatedAssessments });

    //setRefreshPage(refreshPage + 1);
    //validateForm();
  };

  const validateForm = () => {
    const isValid = inputData.TSctRaeoAppAssessments?.every((assess) => {
      if (assess.TSctRaeoMstAssessment.asmIsQuestion === 1) {
        return assess.apasResponse && assess.apasResponse.trim() !== "";
      } else if (assess.TSctRaeoMstAssessment.asmIsQuestion === 2) {
        return assess.apasResponse && assess.apasResponse.trim() !== "";
      } else if (assess.TSctRaeoMstAssessment.asmIsQuestion === 3) {
        const responseParts = assess.apasResponse?.split(":") || [];
        return (
          responseParts[0] && responseParts[1] && responseParts[1].trim() !== ""
        );
      } else {
        return true;
      }
    });

    //onAssessmentValidation();
    return isValid;
  };

  const handleInputChangeDeepWrap = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    handleInputChangeDeep(name, value);
    setRefreshPage(refreshPage + 1);
  };

  //const [errors, setErrors] = useState({});

  const { isLoading } = useHttp();

  return (
    <React.Fragment>
      {isLoading && <MatxLoading />}
      <C1HeaderTitle>Header Information</C1HeaderTitle>
      <Grid
        container
        alignItems="center"
        spacing={3}
        className={classes.gridContainer}
      >
        <Grid item lg={6} md={6} xs={12}>
          <C1InputField
            label="Tracking Reference Number"
            name="appId"
            value={inputData.appId || ""}
            required
            disabled
          />
        </Grid>
        <Grid item lg={6} md={6} xs={12}>
          <C1InputField
            label="RAEO Identifier Number"
            name="aeoNo"
            value={inputData?.TSctRaeo?.aeoNo || ""}
            required
            disabled
          />
        </Grid>
      </Grid>
      <C1HeaderTitle>Company Details</C1HeaderTitle>
      <Grid
        container
        alignItems="flex-start"
        spacing={3}
        className={classes.gridContainer}
      >
        <Grid item lg={6} md={6} xs={12}>
          <C1InputField
            label="TIN / PIN"
            name="TSctRaeoAppDtl.appdTin"
            value={sctRaeoAppDtl.appdTin || ""}
            required
            disabled
            onChange={handleInputChangeDeepWrap}
            inputProps={{ maxLength: 35 }}
            error={errors["TSctRaeoAppDtl.appdTin"] !== undefined}
            helperText={errors["TSctRaeoAppDtl.appdTin"] || ""}
          />
          <C1InputField
            label="Company Full Name"
            name="TSctRaeoAppDtl.appdCompanyName"
            value={sctRaeoAppDtl.appdCompanyName || ""}
            required
            disabled
            onChange={handleInputChangeDeepWrap}
            inputProps={{ maxLength: 255 }}
            error={errors["TSctRaeoAppDtl.appdCompanyName"] !== undefined}
            helperText={errors["TSctRaeoAppDtl.appdCompanyName"] || ""}
          />
        </Grid>
        <Grid item lg={6} md={6} xs={12}>
          <C1SelectField
            label="Nature of Business"
            name="TSctRaeoAppDtl.TSctRaeoMstBzNature.bnId"
            required
            disabled={isDisabled}
            onChange={handleInputChangeDeepWrap}
            value={sctRaeoAppDtl?.TSctRaeoMstBzNature?.bnId || ""}
            error={errors["TSctRaeoAppDtl.TSctRaeoMstBzNature"] !== undefined}
            helperText={errors["TSctRaeoAppDtl.TSctRaeoMstBzNature"] || ""}
          >
            {businessNatureList?.map((item, ind) => (
              <MenuItem value={item.bnId} key={ind}>
                {item.bnName}
              </MenuItem>
            ))}
          </C1SelectField>
          <C1DateField
            label="Business Start Date"
            name="TSctRaeoAppDtl.appdDtBzStart"
            value={sctRaeoAppDtl?.appdDtBzStart}
            required
            disabled={isDisabled}
            onChange={handleDateChange}
            disableFuture={true}
            error={errors["TSctRaeoAppDtl.appdDtBzStart"] !== undefined}
            helperText={errors["TSctRaeoAppDtl.appdDtBzStart"] || ""}
          />
          <C1SelectField
            label="Turnover"
            name="TSctRaeoAppDtl.TSctRaeoMstRange.rangeId"
            value={sctRaeoAppDtl?.TSctRaeoMstRange?.rangeId || ""}
            required
            disabled={isDisabled}
            onChange={handleInputChangeDeepWrap}
            error={errors["TSctRaeoAppDtl.TSctRaeoMstRange"] !== undefined}
            helperText={errors["TSctRaeoAppDtl.TSctRaeoMstRange"] || ""}
          >
            {rangeList?.map((item, ind) => (
            <MenuItem value={item.rangeId} key={ind}>
              {item.rangeId}
            </MenuItem>
            ))}
          </C1SelectField>
        </Grid>
      </Grid>
      <C1HeaderTitle>Applicant Details</C1HeaderTitle>
      <Grid
        container
        alignItems="center"
        spacing={3}
        className={classes.gridContainer}
      >
        <Grid item lg={6} md={6} xs={12}>
          <C1InputField
            label="Name of Applicant"
            name="TSctRaeoAppDtl.appdApplicantName"
            value={sctRaeoAppDtl.appdApplicantName || ""}
            required
            disabled
            onChange={handleInputChangeDeepWrap}
            inputProps={{ maxLength: 125 }}
            error={errors["TSctRaeoAppDtl.appdApplicantName"] !== undefined}
            helperText={errors["TSctRaeoAppDtl.appdApplicantName"] || ""}
          />
          <C1InputField
            label="Position of Applicant"
            name="TSctRaeoAppDtl.appdApplicantPosition"
            value={sctRaeoAppDtl?.appdApplicantPosition || ""}
            required
            disabled={isDisabled}
            onChange={handleInputChangeDeepWrap}
            inputProps={{ maxLength: 125 }}
            error={errors["TSctRaeoAppDtl.appdApplicantPosition"] !== undefined}
            helperText={errors["TSctRaeoAppDtl.appdApplicantPosition"] || ""}
          />
          <C1InputField
            label="Email Address"
            name="TSctRaeoAppDtl.appdEmail"
            value={sctRaeoAppDtl?.appdEmail || ""}
            required
            disabled
            onChange={handleInputChangeDeepWrap}
            inputProps={{ maxLength: 125 }}
            error={errors["TSctRaeoAppDtl.appdEmail"] !== undefined}
            helperText={errors["TSctRaeoAppDtl.appdEmail"] || ""}
          />
          <C1InputField
            label="Telephone Number"
            name="TSctRaeoAppDtl.appdTel"
            value={sctRaeoAppDtl?.appdTel || ""}
            required
            disabled
            onChange={handleInputChangeDeepWrap}
            inputProps={{ maxLength: 35 }}
            error={errors["TSctRaeoAppDtl.appdTel"] !== undefined}
            helperText={errors["TSctRaeoAppDtl.appdTel"] || ""}
          />
        </Grid>
        <Grid item lg={6} md={6} xs={12}>
          <C1InputField
            label="Physical Address 1"
            name="TSctRaeoAppDtl.appdAddr1"
            value={sctRaeoAppDtl?.appdAddr1 || ""}
            required
            disabled
            onChange={handleInputChangeDeepWrap}
            inputProps={{ maxLength: 125 }}
            error={errors["TSctRaeoAppDtl.appdAddr1"] !== undefined}
            helperText={errors["TSctRaeoAppDtl.appdAddr1"] || ""}
          />
{/*           <C1InputField
            label="Physical Address 2"
            name="TSctRaeoAppDtl.appdAddr2"
            value={sctRaeoAppDtl?.appdAddr2 || ""}
            required
            disabled
            onChange={handleInputChangeDeepWrap}
            inputProps={{ maxLength: 125 }}
            error={errors["TSctRaeoAppDtl.appdAddr2"] !== undefined}
            helperText={errors["TSctRaeoAppDtl.appdAddr2"] || ""}
          />
          <C1InputField
            label="Physical Address 3"
            name="TSctRaeoAppDtl.appdAddr3"
            value={sctRaeoAppDtl?.appdAddr3 || ""}
            required
            disabled
            onChange={handleInputChangeDeepWrap}
            inputProps={{ maxLength: 125 }}
            error={errors["TSctRaeoAppDtl.appdAddr3"] !== undefined}
            helperText={errors["TSctRaeoAppDtl.appdAddr3"] || ""}
          /> */}
          <C1SelectField
            label="Country"
            name="TSctRaeoAppDtl.TMstCountry.ctyCode"
            value={sctRaeoAppDtl?.TMstCountry?.ctyCode || ""}
            required
            disabled={isDisabled}
            onChange={handleInputChangeDeepWrap}
            isServer={true}
            error={errors["TSctRaeoAppDtl.TMstCountry"] !== undefined}
            helperText={errors["TSctRaeoAppDtl.TMstCountry"] || ""}
          >
            {countryList &&
              countryList.map((item, ind) => (
                <MenuItem value={item.ctyCode} key={ind}>
                  {item.ctyDescription}
                </MenuItem>
              ))}
          </C1SelectField>
        </Grid>
      </Grid>
      <C1HeaderTitle>Self Assessment</C1HeaderTitle>
      {groupAssessArray &&
        groupAssessArray.map((assGroup, idx) => (
          <Accordion
            expanded={expandedList[idx]}
            onChange={() => handleChange(idx)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id={assGroup?.header?.TSctRaeoMstAssessment?.asmId}
              className={classes.heading}
            >
              <Typography>
                {assGroup?.header?.TSctRaeoMstAssessment?.asmId} &nbsp;
                {assGroup?.header?.TSctRaeoMstAssessment?.asmLabel}
              </Typography>
            </AccordionSummary>

            {assGroup.body.map((assess) => (
              <AccordionDetails>
                <Grid container alignItems="flex-start" spacing={1}>
                  <Grid item lg={6} md={8} xs={14}>
                    <Typography>
                      {assess?.TSctRaeoMstAssessment?.asmId} &nbsp;{" "}
                      {assess.TSctRaeoMstAssessment.asmLabel}
                    </Typography>
                  </Grid>
                  <Grid item lg={6} md={12} xs={24}>
                    <RaeoAppAssessmentItem
                      assess={assess}
                      errors={errors}
                      handleInputChangeCommon={handleInputChangeCommon}
                      handleCheckboxChange={handleCheckboxChange}
                    ></RaeoAppAssessmentItem>
                    {/*assess?.TSctRaeoMstAssessment?.asmIsQuestion === 1 ? (
                                <C1InputField
                                    label="Response"
                                    name="apasResponse"
                                    value={assess.apasResponse || ''}
                                    multiline
                                    rows={3}
                                    required
                                    disabled={isDisabled}
                                    onChange={(e) => handleInputChangeCommon(e, assess.apasId)}
                                    inputProps={{ maxLength: 1024 }}
                                    error={errors[`TSctRaeoAppAssessments[${assess.apasId}].apasResponse`] !== undefined}
                                    helperText={errors[`TSctRaeoAppAssessments[${assess.apasId}].apasResponse`] || ''}
                                />
                            ) :  assess?.TSctRaeoMstAssessment?.asmIsQuestion === 2 ? (
                                <>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        row
                                        aria-label="apasResponse"
                                        name="apasResponse"
                                        value={assess.apasResponse}
                                        onChange={(e) => handleCheckboxChange(e, assess.apasId)}
                                    >
                                        <FormControlLabel
                                            value="Y"
                                            control={<Radio color="primary" />}
                                            label="Yes"
                                            disabled={isDisabled}
                                        />
                                        <FormControlLabel
                                            value="N"
                                            control={<Radio color="secondary" />}
                                            label="No"
                                            disabled={isDisabled}
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </>
                            ) :  assess?.TSctRaeoMstAssessment?.asmIsQuestion === 3 ? (
                                <>
                                <FormControl component="fieldset" fullWidth >
                                    <RadioGroup
                                        row
                                        aria-label="apasResponse"
                                        name="apasResponse"
                                        value={assess.apasResponse?.split(':')[0] || ''}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            const reason = assess.apasResponse?.split(':')[1] || '';
                                            handleInputChangeCommon({
                                                target: {
                                                    name: 'apasResponse',
                                                    value: `${selectedValue}:${reason}`
                                                }
                                            }, assess.apasId);
                                        }}
                                    >
                                        <FormControlLabel
                                            value="Y"
                                            control={<Radio color="primary" />}
                                            label="Yes"
                                            disabled={isDisabled}
                                        />
                                        <FormControlLabel
                                            value="N"
                                            control={<Radio color="secondary" />}
                                            label="No"
                                            disabled={isDisabled}
                                        />
                                    </RadioGroup>
                                    <C1InputField
                                    label="Response"
                                    name="apasResponseReason"
                                    value={assess.apasResponse?.split(':')[1] || ''}
                                    multiline
                                    rows={3}
                                    required
                                    disabled={isDisabled}
                                    onChange={(e) => {
                                        const reason = e.target.value || '';
                                        const selectedValue = assess.apasResponse?.split(':')[0] || '';
                                        handleInputChangeCommon({
                                            target: {
                                                name: 'apasResponse',
                                                value: `${selectedValue}:${reason}`
                                            }
                                        }, assess.apasId);
                                    }}
                                    inputProps={{ maxLength: 1024 }}
                                // error={errors[`TSctRaeoAppAssessments[${idx}].apasResponse`] !== undefined}
                                // helperText={errors[`TSctRaeoAppAssessments[${idx}].apasResponse`] || ''}
                                />
                                </FormControl>
                            </>
                            ) : null */}
                  </Grid>
                </Grid>
              </AccordionDetails>
            ))}
          </Accordion>
        ))}
      ;<Box width={1}>&nbsp;</Box>
      <RaeoHistory auditList={auditList}></RaeoHistory>
      <Box width={1}>&nbsp;</Box>
    </React.Fragment>
  );
};

export default RaeoAppDetails;
